<div class="p-1">
  <app-form-print [questions]="questions" [textButtonSubmit]="dynamicDialogConfig.data.textForm"
    [hideAlertToSubmit]="dynamicDialogConfig.data.hideAlert" [showButtonsSubmit]="showButtonsForm"
    (sendQuestions)="sendQuestions($event)" (cancelQuestions)="dynamicDialogRef.close()">
  </app-form-print>
</div>